<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud :ref="'companiesCrud'" crudName="Empresas" newText="Nova Empresa" :table="table" :columns="columns"
          :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="true" :enableDelete="true"
          :enableView="false" :enableReset="false" :dataForm="dataForm">
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "companiesTable",
      companiesCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "name",
        "status",
        "actions",
      ],
      tableData: [
        "id",
        "name",
        "status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "status"],
        sortable: ["id", "name", "status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        orderBy: { column: 'id', ascending: true },
        headings: {
          id: "ID",
          name: "Nome da Empresa",
          status: "Status",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: "1",
              text: "Ativo",
            },
            {
              id: "0",
              text: "Inativo",
            },
          ],
        },
        templates: {
          status: function (h, row, index) {
            if (row.status === "1" || row.status === 1) {
              return (
                <h5>
                  <span class="badge badge-primary">Ativo</span>
                </h5>
              );
            } else if (row.status === "0" || row.status === 0) {
              return (
                <h5>
                  <span class="badge badge-danger">Inativo</span>
                </h5>
              );
            }

            return (
              <h5>
                <span class="badge badge-secondary">Desconhecido</span>
              </h5>
            );
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "companies",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
